import React, { useState, useEffect, useContext } from 'react';
import dashboardStyles from '../Dashboard.style';
import {
	Table,
	TableBody,
	TableContainer,
	TableRow,
	IconButton,
	Button,
	Box,
	Tooltip
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import bulletIcon from 'assets/svgs/bullet.svg';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import PropTypes from 'prop-types';
import MenuList from './MenuList';
import {
	NAME,
	FREQUENCY,
	FREQUENCY_LOWER,
	TEMPLATE,
	TEMPLATE_NAME,
	LAST_RUN_TIME,
	LAST_RUN_DATE,
	STATUS,
	STATUS_LOWER,
	REPORT_NAME,
	DOT_SPACING,
	SCHEDULED,
	SHARED,
	EXPIRATION_DATE,
	ALERT_FOR_EPIRING_REPORTS,
	BTN_TO_SEE_EXPIRING_REPORTS,
	BTN_TO_SEE_EXPIRING_REPORTS_TOOLTIP,
	REPORT_SPECIAL_KEYS,
	PROJECTS,
	BASIC,
	NOW,
	ONCE,
	LATER,
	TODAY,
	PURGE_DATE,
	SHOW_REPORT_EXPIREING_ALERT
} from 'constants/constant';
import { getLastRun } from 'helper/utils';
import { computeWidths, computeHeight, computeFontSize } from './utils/dashboard-utils';
import useScreenWidthSize from './hooks/useScreenWidthSize';
import MyTableCellHOC from './styled-components/MyTableCellHOC';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import CloseIcon from '@material-ui/icons/Close';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import FilterBy from '../components/FilterBy';
import MetaData from '../meta-data/MetaData';
import CustomPagination from './CustomPagination';
import NoReports from './NoReports';
import ReportTableHeader from './ReportTableHeader';
import { dbSortBy, dbSortDirection } from '../Dashboard.actions';
import NoDataPage from '../../Shared/NoDataPage';
import { isObjEmpty } from 'helper/helper';
import { UserPortalContext } from 'context/appcontext';

const fieldMapping = [
	{ name: STATUS, field: STATUS_LOWER },
	{ name: TEMPLATE, field: TEMPLATE_NAME },
	{ name: FREQUENCY, field: FREQUENCY_LOWER }
];

function ActiveReportTable(props) {
	const { reportData, handleDownload, isSmallScreen, callReportSaved, cbShowSharedReport } = props;
	const { tabValue, searchTxt, filterBy, sharedReportTabValue } = useSelector(
		(state) => state.dashboardReducer
	);
	const target = React.useRef(null);
	const figmaBreakPoint = useScreenWidthSize();
	const widths = computeWidths(figmaBreakPoint);
	const height = computeHeight(figmaBreakPoint);
	const fontHeight = computeFontSize(figmaBreakPoint);
	const classes = dashboardStyles({ isSmallScreen });
	const portalUserContext = useContext(UserPortalContext);
	const { customerType } = portalUserContext;
	const [showExpAlert, setShowExpAlert] = useState(
		localStorage.getItem(SHOW_REPORT_EXPIREING_ALERT) === 'true'
	);
	const [dispAlertList, setDispAlertList] = useState(0);
	const [selectedRow, setSelectedRow] = useState(null);
	const [show, setShow] = useState(false);
	const [filteredData, setFilteredData] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageCount, setPageCount] = useState(1);
	const [previewingData, setPreviewingData] = useState([]);

	const reportsList = useSelector((state) =>
		tabValue === PROJECTS ? state.dashboardReducer.reportsList : state.dashboardReducer.sharedList
	);
	const dispatch = useDispatch();
	const onPageChange = (event, value) => {
		setCurrentPage(value);
		const start = (value - 1) * 10;
		const end = start + 10;
		setPreviewingData(filteredData?.slice(start, end));
	};

	useEffect(() => {
		setPreviewingData(reportData);
	}, [reportData.length]);

	useEffect(() => {
		let count = 0;

		if (showExpAlert && checkExpiringReports()) {
			count += 1;
		}

		setDispAlertList(count);
		setPageCount(Math.ceil(reportData.length / 10));
	}, []);

	useEffect(() => {
		const search = (element) => {
			return Object.keys(filterBy).every((key) => {
				const f = fieldMapping.filter((el) => el.name === key).map((value) => value.field)[0];
				const n = fieldMapping.filter((el) => el.name === key).map((value) => value.name)[0];
				return filterBy[n].map((itm) => itm?.toUpperCase()).includes(element[f]?.toUpperCase());
			});
		};
		if (isObjEmpty(filterBy)) {
			setFilteredData(reportData);
		}

		if (filterBy[FREQUENCY]?.includes(ONCE)) {
			const idx = filterBy[FREQUENCY]?.indexOf(ONCE);
			filterBy[FREQUENCY]?.splice(idx, 1);
			filterBy[FREQUENCY]?.push(NOW);
		}

		const filterReportData = reportData.filter(search);
		setFilteredData(filterReportData);
		setPreviewingData(filterReportData.slice(0, 10));
		setPageCount(Math.ceil(filterReportData.length / 10));
		setCurrentPage(1);
	}, [JSON.stringify(filterBy), reportData]);

	const headers = [
		{ name: STATUS, field: STATUS_LOWER },
		{ name: NAME, sortBy: REPORT_NAME, field: REPORT_NAME },
		{ name: TEMPLATE, field: TEMPLATE_NAME },
		{ name: FREQUENCY, field: FREQUENCY_LOWER },
		{ name: LAST_RUN_TIME, sortBy: LAST_RUN_DATE, field: LAST_RUN_DATE },
		{ name: EXPIRATION_DATE, sortBy: PURGE_DATE, field: PURGE_DATE },
		{ name: undefined }
	];

	const getBulletIcon = (item) => {
		if (item?.sharedWith?.viewed || item.downloadCount !== 0) {
			return;
		}
		return (
			<div style={{ alignSelf: 'center', marginTop: '-20px' }}>
				<img className={classes.bullet} src={bulletIcon} alt="bullet-icon"></img>
			</div>
		);
	};

	const showAlert = (purgeDate) => {
		const diff = moment(purgeDate).subtract(3, 'day').isBefore(moment());
		return diff;
	};

	const checkExpiringReports = () => {
		// If any one of the report from entire list has expiry, it should show the Alert
		let list = reportsList;
		if (tabValue === SHARED && sharedReportTabValue === 0) {
			list = reportsList.filter(
				(report) =>
					report.sharedWith.isDataIncluded === undefined ||
					report.sharedWith.isDataIncluded === true
			);
		}
		const _ret = list.find((item) => {
			if (showAlert(item.purgeDate)) {
				return true;
			}
		});

		return _ret;
	};

	if (reportData.length === 0 && searchTxt.length > 0) {
		return (
			<Box className={classes.errorContainer}>
				<NoDataPage
					errorMsg={'No Results Found. Try a different keyword.'}
					isSmallScreen={isSmallScreen}
				/>
			</Box>
		);
	}
	return (
		<>
			<FilterBy />
			{showExpAlert && checkExpiringReports() && (
				<Alert className={classes.showAlertForExpiringReport} severity="warning">
					<span>{ALERT_FOR_EPIRING_REPORTS}</span>
					<Box sx={{ flexGrow: 1 }} />
					<Button
						className={classes.btnAlertForExpiringReport}
						onClick={(e) => {
							if (REPORT_SPECIAL_KEYS.includes(e.key)) {
								return;
							}
							dispatch(dbSortBy(PURGE_DATE));
							dispatch(dbSortDirection('desc'));
						}}>
						{BTN_TO_SEE_EXPIRING_REPORTS}
					</Button>
					<IconButton
						size="small"
						onClick={() => {
							localStorage.setItem(SHOW_REPORT_EXPIREING_ALERT, false);
							setShowExpAlert(false);
							setDispAlertList((prev) => prev - 1);
						}}>
						<CloseIcon fontSize="inherit" />
					</IconButton>
				</Alert>
			)}

			<TableContainer
				className={classes.tableContainer}
				style={{
					height:
						// Basic user account Banner is 40px, need to shorten or else pagination will not be visible
						customerType == BASIC
							? `calc(460px - ${dispAlertList * 45}px)`
							: `calc(500px - ${dispAlertList * 45}px)`
				}}>
				<Table
					ref={target}
					stickyHeader
					className={classes.table}
					height={height}
					role="grid"
					id="retort-table"
					aria-labelledby="scheduled reports table"
					aria-label="scheduled reports table">
					<ReportTableHeader
						headers={headers}
						widths={widths}
						height={height}
						fontHeight={fontHeight}
					/>
					{previewingData.length ? (
						<TableBody>
							{previewingData?.map((item, index) => (
								<TableRow
									className={`${classes.tableRow} ${
										item.status === SCHEDULED ? classes.highlightRow : null
									}`}
									id={`report-${currentPage}-${index}`}
									key={item.reportId}
									onClick={() => {
										// getSelectedRows(item);
										setSelectedRow(item);
										setShow(true);
									}}>
									<MyTableCellHOC
										width={widths[0]}
										height={height}
										fontSize={fontHeight}
										style={{ textTransform: 'capitalize' }}
										downloadCount={item.downloadCount}>
										{item?.status?.split('_').join(' ').toLowerCase()}
									</MyTableCellHOC>
									<MyTableCellHOC
										style={{ display: 'flex' }}
										width={widths[1] - DOT_SPACING}
										height={height}
										fontSize={fontHeight}
										downloadCount={item.downloadCount}>
										<div
											style={{
												textOverflow: 'ellipsis',
												overflow: 'hidden',
												whiteSpace: 'nowrap',
												maxWidth: widths[1] - DOT_SPACING,
												flexBasis: 'min-content',
												alignSelf: 'center',
												fontFamily: 'inherit'
											}}>
											{item.reportName}
										</div>
										{(item.sharedWith?.length > 0 || tabValue === SHARED) && (
											<div style={{ alignSelf: 'center' }}>
												<PeopleAltIcon alt="share-icon" className={classes.shareIcon} />
											</div>
										)}
										{getBulletIcon(item)}
									</MyTableCellHOC>
									<MyTableCellHOC
										downloadCount={item.downloadCount}
										width={widths[2]}
										height={height}
										fontSize={fontHeight}>
										<div
											style={{
												textOverflow: 'ellipsis',
												overflow: 'hidden',
												whiteSpace: 'nowrap',
												fontFamily: 'inherit'
											}}>
											{item.templateName}
										</div>
									</MyTableCellHOC>
									<MyTableCellHOC
										downloadCount={item.downloadCount}
										width={widths[3]}
										height={height}
										fontSize={fontHeight}>
										{[NOW, LATER, TODAY].includes(item.frequency) ? ONCE : item.frequency}
									</MyTableCellHOC>
									<MyTableCellHOC
										downloadCount={item.downloadCount}
										width={widths[4]}
										height={height}
										fontSize={fontHeight}>
										{getLastRun(item.lastRunDate)}
									</MyTableCellHOC>
									<MyTableCellHOC
										downloadCount={item.downloadCount}
										width={widths[4]}
										height={height}
										fontSize={fontHeight}>
										<span style={{ fontFamily: 'inherit' }}>
											{moment(item.purgeDate).format('MM/DD/YYYY')}
										</span>
										{showAlert(item.purgeDate) && (
											<Tooltip
												title={BTN_TO_SEE_EXPIRING_REPORTS_TOOLTIP}
												placement={'bottom'}
												classes={{ tooltip: classes.customWidth }}>
												<ReportProblemOutlinedIcon
													style={{
														fontSize: '14px',
														marginLeft: '18px'
													}}
												/>
											</Tooltip>
										)}
									</MyTableCellHOC>
									<MyTableCellHOC
										style={{ height: '48px', maxHeight: '48px', border: '0px' }}
										className={`${classes.tableCell} ${
											item.downloadCount === 0 ? classes.newTableCell : classes.prevTableCell
										}`}>
										<MenuList
											rowData={item}
											index={index}
											handleDownload={handleDownload}
											handleShareReport={cbShowSharedReport}
											callReportSaved={callReportSaved}
										/>
									</MyTableCellHOC>
								</TableRow>
							))}
						</TableBody>
					) : (
						<NoReports />
					)}
				</Table>
			</TableContainer>
			<Box>
				{filteredData?.length > 0 && reportData?.length > 10 && (
					<CustomPagination
						onPageChange={onPageChange}
						currentPage={currentPage}
						pageCount={pageCount}
					/>
				)}
			</Box>

			<MetaData data={selectedRow} show={show} setShow={setShow} />
		</>
	);
}

ActiveReportTable.propTypes = {
	handleDownload: PropTypes.func,
	isSmallScreen: PropTypes.bool
};

export default ActiveReportTable;
